import { lazy } from 'react'

export const Layout = lazy(() => import('./layout'))
export const ProfileSettings = lazy(() => import('./profile-settings'))
export const AccountSettings = lazy(() => import('./account-settings'))
